import React, { useMemo } from "react";
import Tiger from "../pages/tiger";
import TurnVictory from "../pages/turnVictory";
import BackWin from "../pages/backWin";
import BaccaratWin from "../pages/baccaratWin";
import FirstDeposit from "../pages/firstDeposit";
import OldBringNew from "../pages/oldBringNew";
import { useTranslation } from "react-i18next";
import Fish from "../pages/fish";
import { COMMON_WEB_PATH } from "../../../constant";
import Recommend from "../../../components/Rules/Recommend";

const List = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.${key}`);
  const i18n_recommend = (key) => t(`recommend.${key}`);

  // 動態生成圖片路徑
  const getImagePath = (imageName = "") => {
    return `${COMMON_WEB_PATH}/promotion/${i18n("lang")}/${imageName}.webp`;
  };

  return [
    // {
    //   good_uid: "Activity231115",
    //   title: i18n("fish.title"),
    //   subTitle: i18n("fish.subTitle"),
    //   // image_chs:
    //   //   "https://911win.co/images/viet/FishingMachine_mobile_viet.webp",
    //   // image_pc_chs: "https://911win.co/images/viet/FishingMachine_pc_viet.webp",
    //   image_mobile: getImagePath("FishingMachine_mobile"),
    //   image_pc: getImagePath("FishingMachine_pc"),
    //   start_date: "2023-11-15",
    //   promotion_content: <Fish />,
    //   condition: [
    //     {
    //       label: i18n("fish.condition.1"),
    //     },
    //   ],
    //   conditionKeys: ["lose"],
    //   navigate: "/casino/category/all/Fish",
    //   buttonText: "Go to play Slots->Fish category games",
    //   includesType: ["FH"],
    // },

    // {
    //   good_uid: 127,
    //   title: i18n("tigerPromotion.title"),
    //   subTitle: i18n("tigerPromotion.subTitle"),
    //   // image_chs: "https://911win.co/images/viet/ConquerSlot_mobile_viet.webp",
    //   // image_pc_chs: "https://911win.co/images/viet/ConquerSlot_pc_viet.webp",
    //   image_mobile: getImagePath("ConquerSlot_mobile"),
    //   image_pc: getImagePath("ConquerSlot_pc"),
    //   start_date: "2023-10-25",
    //   promotion_content: <Tiger />,
    //   condition: [
    //     {
    //       label: i18n("tigerPromotion.condition.1"),
    //     },
    //     {
    //       label: i18n("tigerPromotion.condition.2"),
    //     },
    //   ],
    //   conditionKeys: [],
    //   navigate: "profile/betRecord",
    //   buttonText: "Go to betting record",
    //   buttonNotShow: true,
    // },
    // {
    //   good_uid: "activity231018",
    //   title: i18n("turnVictoryPromotion.title"),
    //   subTitle: i18n("turnVictoryPromotion.subTitle"),
    //   // image_chs: "https://911win.co/images/viet/TurnVictory_mobile_viet.webp",
    //   // image_pc_chs: "https://911win.co/images/viet/TurnVictory_pc_viet.webp",
    //   image_mobile: getImagePath("TurnVictory_mobile"),
    //   image_pc: getImagePath("TurnVictory_pc"),
    //   start_date: "2023-10-18",
    //   promotion_content: <TurnVictory />,
    //   condition: [
    //     {
    //       label: i18n("turnVictoryPromotion.condition.1"),
    //     },
    //   ],
    //   conditionKeys: ["lose"],
    //   navigate: "/casino",
    //   buttonText: "Go to play Slots games",
    //   includesType: ["SLOT", "TABLE", "FH", "EGAME"],
    // },
    {
      title: i18n("return911Promotion.title"),
      subTitle: i18n("return911Promotion.subTitle"),
      // image_chs: "https://911win.co/images/viet/Return911_mobile_viet.webp",
      // image_pc_chs: "https://911win.co/images/viet/Return911_pc_viet.webp",
      image_mobile: getImagePath("Return911_mobile"),
      image_pc: getImagePath("Return911_pc"),
      start_date: "2023-10-12",
      promotion_content: <BackWin />,
      condition: [
        {
          label: i18n("return911Promotion.condition.1"),
        },
        {
          label: i18n("return911Promotion.condition.2"),
        },
      ],
    },
    {
      title: i18n("baccaratWinPromotion.title"),
      subTitle: i18n("baccaratWinPromotion.subTitle"),
      // image_chs: "https://911win.co/images/viet/bais.jpg",
      // image_pc_chs: "https://911win.co/images/viet/bais.jpg",
      image_mobile: getImagePath("bais_mobile"),
      image_pc: getImagePath("bais_pc"),
      start_date: "2018-07-01",
      promotion_content: <BaccaratWin />,
      condition: [
        {
          label: i18n("baccaratWinPromotion.condition.1"),
        },
        {
          label: i18n("baccaratWinPromotion.condition.2"),
        },
        {
          label: i18n("baccaratWinPromotion.condition.3"),
        },
        {
          label: i18n("baccaratWinPromotion.condition.4"),
        },
        {
          label: i18n("baccaratWinPromotion.condition.5"),
        },
        // {
        //   label: i18n("baccaratWinPromotion.condition.6"),
        // },
        // {
        //   label: i18n("baccaratWinPromotion.condition.7"),
        // },
        // {
        //   label: i18n("baccaratWinPromotion.condition.8"),
        // },
        // {
        //   label: i18n("baccaratWinPromotion.condition.9"),
        // },
        // {
        //   label: i18n("baccaratWinPromotion.condition.10"),
        // },
        // {
        //   label: i18n("baccaratWinPromotion.condition.11"),
        // },
      ],
    },
    {
      title: i18n("firstDepositPromotion.title"),
      subTitle: i18n("firstDepositPromotion.subTitle"),
      // image_chs: "https://911win.co/images/viet/hois.jpg",
      // image_pc_chs: "https://911win.co/images/viet/hois.jpg",
      image_mobile: getImagePath("hois_mobile"),
      image_pc: getImagePath("hois_pc"),
      start_date: "",
      promotion_content: <FirstDeposit />,
      condition: [
        {
          label: i18n("firstDepositPromotion.condition.1"),
        },
        {
          label: i18n("firstDepositPromotion.condition.2"),
        },
        // {
        //   label: i18n("firstDepositPromotion.condition.3"),
        // },
      ],
    },
    {
      title: i18n("oldBringNewPromotion.title"),
      subTitle: i18n("oldBringNewPromotion.subTitle"),
      // image_chs: "https://911win.co/images/viet/diems.jpg",
      // image_pc_chs: "https://911win.co/images/viet/diems.jpg",
      image_mobile: getImagePath("diems_mobile"),
      image_pc: getImagePath("diems_pc"),
      start_date: "",
      promotion_content: <OldBringNew />,
      condition: [
        {
          label: i18n("oldBringNewPromotion.condition.1"),
        },
        {
          label: i18n("oldBringNewPromotion.condition.2"),
        },
        {
          label: i18n("oldBringNewPromotion.condition.3"),
        },
        {
          label: i18n("oldBringNewPromotion.condition.4"),
        },
        {
          label: i18n("oldBringNewPromotion.condition.5"),
        },
      ],
    },
    {
      title: i18n_recommend("Recommend to friends"),
      subTitle: i18n_recommend(
        "There is no threshold to become a 911 entertainment agent, no investment cost, everyone can become an agent!"
      ),
      type: "recommend",
      image_mobile: getImagePath("invite_mobile"),
      image_pc: getImagePath("invite_pc"),
      start_date: "",
      promotion_content: <Recommend />,
      condition: [
        {
          label: i18n_recommend(
            "Just register on the official website and log in to the game, and share your exclusive QR code. When you become a member of the 911 official website through the exclusive QR code you share, you can check the membership (agent) in [Agent Join] and My Commission For related information, at this time, the system will automatically upgrade you to become an agent of 911 Entertainment. Whether you play the game yourself or someone becomes your agent one after another, you will get your own betting commission + unlimited-level agent performance commission every week. The total amount of commissions for each performance allows you to easily earn a pot of gold without knowing it."
          ),
        },
      ],
    },
  ];
};

export default List;
